import { useQuery } from "@tanstack/react-query";
import { getCalendar } from "@/api/calendar";
import { CalendarFilters } from "@/api/calendar/types";


export function useCalendar(filters?: CalendarFilters) {
  return useQuery({
    queryKey: ['calendar', filters],
    queryFn: () => getCalendar(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}